import React from "react"
import classes from "./Backdrop.module.scss"

const Backdrop = ({ show, close, params }) =>
  show ? (
    <div className={classes.backdrop} onClick={() => close(params)} />
  ) : null

export default Backdrop
